import React from "react";
import { ChevronDown } from "lucide-react";

interface PhoneInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
}

const PhoneInput: React.FC<PhoneInputProps> = ({ value, onChange, error }) => {
  return (
    <div>
      <label
        htmlFor="phoneNumber"
        className="block text-sm font-medium text-gray-700"
      >
        Phone Number
      </label>
      <div className="mt-1 flex rounded-md shadow-sm">
        <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm">
          <div className="flex items-center">
            +234
            <ChevronDown className="ml-1 h-4 w-4" />
          </div>
        </span>
        <input
          type="text"
          name="phoneNumber"
          id="phoneNumber"
          value={value}
          onChange={onChange}
          className={`flex-1 min-w-0 block w-full px-3 py-2 rounded-none rounded-r-md border ${
            error ? "border-red-500" : "border-gray-300"
          }  sm:text-sm`}
          placeholder="8056167793"
        />
      </div>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
    </div>
  );
};

export default PhoneInput;
